export function getContextParamsfromOfficeContext(componentContext) {
    var context = {
        cdnDomain: componentContext.cdnDomain,
        browserPathAndQueryString: componentContext.browserPathAndQueryString || '',
        buildDateUtc: componentContext.buildDateUtc,
        buildVersion: componentContext.buildVersion,
        correlationId: componentContext.correlationId,
        deploymentEnvironment: componentContext.deploymentEnvironment,
        disableLegacyNetworkConfigs: componentContext.disableLegacyNetworkConfigs || false,
        domainOrigin: componentContext.domainOrigin,
        ecsRing: componentContext.ecsRing || '',
        flights: componentContext.flights || '',
        geoName: componentContext.geoName,
        inMockMode: componentContext.inMockMode,
        isCorpNet: componentContext.isCorpNet,
        mockReactShell: componentContext.mockReactShell || false,
        officeHomeApiRoot: componentContext.officeHomeApiRoot,
        officeMarketLcid: componentContext.officeMarketLcid,
        officeStartManifestVersion: componentContext.officeStartManifestVersion,
        preferredCulture: componentContext.preferredCulture,
        requestOrigin: componentContext.requestOrigin,
        rootPath: componentContext.rootPath || 'v3/apphosted',
        sessionId: componentContext.sessionId,
        stringsContainerName: 'officestartstrings',
        useLocalFiles: componentContext.useLocalFiles || false,
        testTraffic: componentContext.testTraffic || false,
    };
    return context;
}
//# sourceMappingURL=Utils.js.map